import {Component, inject} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ErrorType} from '../../model/error-type';
import { EMessageType, MessageComponent } from '../generic/message/message.component';
import {AuthenticationService} from '../../services/auth/authentication.service';
import {SessionService} from '../../services/session.service';
import {MandantService} from '../../services/mandant.service';
import {RestErrorHelper} from '../../helper/rest-error-helper';
import {RightsService} from '../../services/rights.service';
import { NgIf } from '@angular/common';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
    selector: 'app-auth-redirect',
    templateUrl: './auth-redirect.component.html',
    styleUrls: ['./auth-redirect.component.scss'],
    standalone: true,
    imports: [NgIf, ProgressSpinnerModule, MessageComponent]
})
export class AuthRedirectComponent
{
  private rightsService = inject(RightsService);

  loading = true;
  errorMsg: ErrorType;

  redirectUrl: string;

  constructor(private route: ActivatedRoute,
              private authenticationService: AuthenticationService,
              private sessionService: SessionService,
              private mandantService: MandantService,
              private restErrorHelper: RestErrorHelper)
  {
    this.initUrlParameter();
  }

  private initUrlParameter(): void
  {
    if (this.route.snapshot.queryParamMap.has('token') && this.route.snapshot.queryParamMap.has('url') &&
      this.route.snapshot.queryParamMap.has('mandantKey'))
    {
      const token = this.route.snapshot.queryParamMap.get('token');
      this.redirectUrl = this.route.snapshot.queryParamMap.get('url');
      const mandantKey = this.route.snapshot.queryParamMap.get('mandantKey');

      this.authenticationService.loginSuccessful(token, undefined, undefined);
      this.selectMandant(+mandantKey);

      console.log('Url: ' + this.redirectUrl);
      // window.open(url, '_self');
    }
    else
    {
      console.log('Parameter token nicht gegeben');

      this.loading = false;
      this.errorMsg = new ErrorType();
      this.errorMsg.closable = true;
      this.errorMsg.message = 'Parameter nicht angegeben / parameter not set correctly';
      this.errorMsg.severity = EMessageType.warn;
    }
  }

  public selectMandant(mandantKey: number): void
  {
    this.errorMsg = undefined;
    this.loading = true;

    const username = localStorage.getItem('2k-username');

    console.log('selectMandant, username: ' + username + ', mandantKey: ' + mandantKey);

    this.authenticationService.changeMandant(username, mandantKey).subscribe({
      next: data =>
      {
        console.log('Rechte erfolgreich erhalten.', data);
        this.authenticationService.mandantChanged(data.mandant, data.rights, this.sessionService, this.rightsService);

        this.mandantService.getMandantSettings(true).subscribe({
          next: responseData =>
          {
            console.log('Einstellungen erhalten', responseData);
            this.loading = false;
            window.open(this.redirectUrl, '_self');
            // this.openUrlAfterLogin(environment.backendPrefix + '/');
          },
          error: error =>
          {
            console.log('Fehler beim Laden der Mandant-Einstellungen', error);
            this.loading = false;
            this.errorMsg = this.restErrorHelper.getErrorType(error);
          }
        });
      },
      error: error =>
      {
        console.log('error', error);
        this.loading = false;
        localStorage.removeItem('2k-mandant');
        this.errorMsg = this.restErrorHelper.getErrorType(error);
      }
    });
  }
}
